import AIAction1 from "assets/images/AIAction1.svg";
import AIAction2 from "assets/images/AIAction2.svg";
import AIAction3 from "assets/images/AIAction3.svg";

const AIRecommendContent = ({ data }: any) => {
  return (
    <div className="row mt-5 justify-content-between">
      <div className="col-3 bg-gray-900">
        <img src={data.img} alt={data.heading} />
      </div>
      <div className="col-6">
        <div className="text-7s fw-400 text-uppercase text-gray-400">Recommended</div>
        <h5>{data.heading}</h5>
        <p className="text-1x fw-300 text-gray-400">{data.subHeading}</p>
        <div className="d-flex">
          {Object.keys(data.frequence)?.map((item: string, i: number) => (
            <div key={i} className={`ph-3 ${i !== Object.keys(data.frequence)?.length - 1 ? 'border-end' : ''}`}>
              <div className="fw-400 text-uppercase text-7s text-gray-500">
                {item}
              </div>
              <div className="fw-300 text-2c">
                {data.frequence[item]}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="col-2">
        <button className="btn btn-outline-secondary text-white flex-center w-100 mv-2">
          <i className="icon-plus text-5c mr-2"></i>
          Add to plan
        </button>
        <button className="btn btn-outline-secondary text-white flex-center w-100 mv-3">
          <i className="icon-eye text-5c mr-2"></i>
          Compare
        </button>
      </div>
    </div>
  );
};

export default function AIRecommendedActions() {
  const data = [
    {
      id: '1',
      img: AIAction1,
      heading: 'Find a new vendor in unaffected region',
      subHeading: 'Finding a new vendor in another region will allow you to continue operations as usual. This has a low risk but high cost.',
      frequence: {
        'speed': 'Fast',
        'risk': 'Low',
        'cost': 'High'
      }
    },
    {
      id: '2',
      img: AIAction2,
      heading: 'Bring more manufacturing in-house',
      subHeading: 'Bringing in more manufacturing in-house will give you greater control of your supply chain. This has a long ramp-up time and cost involved though.',
      frequence: {
        'speed': 'Slow',
        'risk': 'Low',
        'cost': 'High'
      }
    },
    {
      id: '3',
      img: AIAction3,
      heading: 'Purchase new vendor',
      subHeading: 'We found 3 vendors who have been negatively affected by the supply chain issues. This would be a good time to buy at a lower price and control the market.',
      frequence: {
        'value': 'Medium',
        'risk': 'Low',
        'cost': 'High'
      }
    }
  ];

  return (
    <div className="pv-3">
      {data.map((item, index) => (
        <AIRecommendContent data={item} />
      ))}
    </div>
  );
}
